<template>
  <div>筛查建议</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>